import moment from "moment/moment"

export const formatRange = v => ({
    from: moment(v.from).startOf('day').valueOf(),
    to: moment(v.to).endOf('day').valueOf(),
})